import Mustache from "mustache";
export const openSecondModal = (modalId) => {
  if ($(".modal.show").length > 0) {
    const currentOpenModalId = $(".modal.show").attr("id");
    $("#" + currentOpenModalId).on("hidden.bs.modal", function () {
      $("#" + modalId).modal("show");
      $("#" + currentOpenModalId).off("hidden.bs.modal");
    });
    $("#" + currentOpenModalId).modal("hide");
  } else {
    $("#" + modalId).modal("show");
  }
};

export const renderMustacheTemplate = (
  templateId,
  templateData,
  target,
  callback
) => {
  const template = $(templateId).html();
  const rendered = Mustache.render(template, templateData);
  $(target)
    .html(rendered)
    .promise()
    .done(function () {
      typeof callback === "function" && callback();
    });
};
export const ts = Math.round(new Date().getTime() / 1000);
export const randomInt = (min, max) =>
  min + Math.floor((max - min) * Math.random());
export const roundNumber = (x) => (x < 10 ? "0" + x : x);

export const setInSelectByText = (select, obj, key) => {
  select.forEach(function (location) {
    let options = location.options;
    if (typeof location.options !== "undefined") {
      for (let i = 1; i < options.length; i++) {
        if ($(options[i]).data("location_name") === obj[key]) {
          options[i].selected = true;
          $(location).trigger("change");
          break;
        } else {
          options[i].selected = false;
        }
      }
    }
  });
};
